import type { Messages } from './en';

/** 第三階段內容：遊樂場小遊戲（全部原創設計）（繁體中文・台灣）。 */
export const zhTWArcade: Pick<Messages, 'arcade'> = {
  arcade: {
    title: '🕹️ 遊樂場',
    hint: '選一個遊戲吧！拿到好成績可以賺星星（每個遊戲每天有上限）。',
    play: '▶ 開始玩',
    again: '🔁 再玩一次',
    back: '⬅ 遊戲列表',
    score: '分數',
    best: '最高分',
    over: '遊戲結束！',
    win: '你贏了！',
    earned: (n: number) => `獲得 +${n}⭐`,
    capped: '這個遊戲今天的星星已經拿完了——就玩個開心吧！',
    tap: '點一下開始',
    games: {
      volleyball: { name: '排球對打', how: '用 ◀ ▶ 移到球的下方，按 ● 把球托過網。別讓球掉下來！' },
      tennis: { name: '網球揮拍', how: '用 ◀ ▶ 移到球的位置，球來到你面前時按 ● 把它打回去。' },
      rhythm: { name: '鋼琴節奏', how: '音符碰到線的時候點那一排。每打中一下就會彈出一個音！' },
      drawing: { name: '塗鴉本', how: '用手指畫畫。選好顏色和筆刷，再分享到 PixelBook！' },
      racing: { name: '街頭賽車', how: '用 ◀ ▶ 轉向閃過車流、收集硬幣。速度會越來越快喔！' },
      circus: { name: '馬戲團雜耍', how: '球落到哪隻手，就按 ◀ 或 ▶ 把它再拋上去。' },
      minesweeper: { name: '地鼠花園', how: '點一下就挖。數字代表附近躲了幾隻地鼠。用 🚩 模式把牠們標記起來。' },
      snake: { name: '貪吃毛毛蟲', how: '用方向鍵或滑動來控制。吃葉子會變長，別咬到自己！' },
      baseball: { name: '全壘打大賽', how: '球飛到本壘板時按 ● 揮棒。時機完美＝全壘打！' },
      maze: { name: '螢火蟲花園', how: '在樹籬迷宮裡飛來飛去收集光點。發光的花會讓青蛙睡著！' },
      match3: { name: '水果消消樂', how: '交換兩個相鄰的水果，連成 3 個以上就能消除。共 25 步！' },
      puzzle: { name: '滑塊拼圖', how: '把方塊照 1–8 的順序排好。' },
      blocks: { name: '方塊堆疊', how: '用落下的方塊把整排填滿消除。' },
      goldfish: { name: '撈金魚', how: '把紙網伸到魚下面再撈起來。動作要輕，不然紙會破！金魚算 3 分。' },
      ringToss: { name: '套圈圈', how: '用 ◀ ▶ 瞄準，按住 ●（或螢幕），力道剛好時放開。共 10 個圈！' },
      claw: { name: '夾娃娃', how: '用 ◀ ▶（或拖曳）移動夾子，按 ● 放下，把娃娃送到出口。共 5 次！' },
      dragonBoat: { name: '龍舟競賽', how: '跟著鼓聲輪流按 ◀ ▶ 划槳。到終點時按 ● 奪標！' },
      stoneStack: { name: '七星潭疊石頭', how: '點一下讓擺動的石頭落下，疊得穩穩的。小心海風！' },
    },
    drawing: {
      prompt: '今天的題目：',
      prompts: ['一隻貓', '你的家人', '一棵櫻花樹', '你夢想中的家', '下雨天', '你最好的朋友', '一隻怪獸'],
      clear: '🗑️',
      eraser: '🧽',
      share: '📤 分享到 PixelBook',
      shared: '分享成功！朋友們都超喜歡的。',
    },
    mines: { dig: '⛏️ 挖掘', flag: '🚩 插旗', left: (n: number) => `🐹 還剩 ${n} 隻` },
  },
};
